module.exports = __webpack_public_path__ + "img/car.0c753198.svg";